import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CheckYourEmailText } from './constants';

import { GoodkindTheme } from '../../../../../global/theme';
import {
	CheckYourEmailBanner,
	SendIconContainer,
	DescriptionContainer,
	ResendContainer,
} from './CheckYourEmail.styles';
import { LinkButton, Title, Text, Icon } from '@nicheinc/campus-ds';

export default function CheckYourEmail() {
	const navigate = useNavigate();

	return (
		<CheckYourEmailBanner>
			<Icon iconName="goodkindlogo" size="xxl" />

			<SendIconContainer>
				<Icon iconName="sendIcon" size="xxl" />
			</SendIconContainer>

			<DescriptionContainer>
				<Title color={GoodkindTheme.colors.dark[700]}>
					{CheckYourEmailText.HEADING}
				</Title>

				<Text size="large">{CheckYourEmailText.DESCRIPTION}</Text>

				<ResendContainer>
					<Text color={GoodkindTheme.colors.dark[700]} size="large">
						{CheckYourEmailText.FAILED_RECEIVING}
					</Text>

					<LinkButton
						size="large"
						onClick={() => navigate('/?login_hint=signup')}
					>
						{CheckYourEmailText.RESEND}
					</LinkButton>
				</ResendContainer>
			</DescriptionContainer>
		</CheckYourEmailBanner>
	);
}
